<template>
  <blueprint-wrapper>
    <blueprint-header>
      <job-request-header/>
      <div class="SPACER"/>
      <job-request-info-heading/>
      <job-request-navigation/>
    </blueprint-header>
    <blueprint-content>
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>
    </blueprint-content>
    <blueprint-footer>
      <footer-lower/>
    </blueprint-footer>
  </blueprint-wrapper>
</template>

<script>
import FooterLower from '@/layouts/components/AppFooterLower';
import BlueprintWrapper from '@/components/Blueprint/BlueprintWrapper';
import BlueprintHeader from '@/components/Blueprint/BlueprintHeader';
import BlueprintContent from '@/components/Blueprint/BlueprintContent';
import BlueprintFooter from '@/components/Blueprint/BlueprintFooter';
import JobRequestHeader from './components/JobRequestHeader';
import JobRequestInfoHeading from './components/JobRequestInfoHeading';
import JobRequestNavigation from './components/JobRequestNavigation';

export default {
  name: 'job-request-layout',
  components: {
    FooterLower,
    JobRequestHeader,
    JobRequestInfoHeading,
    JobRequestNavigation,
    BlueprintWrapper,
    BlueprintHeader,
    BlueprintContent,
    BlueprintFooter,
  },
};
</script>
<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .SPACER {
    height: 82px;
  }
</style>
